import { render, staticRenderFns } from "./ModalCategory.vue?vue&type=template&id=a3eb52f8"
import script from "./ModalCategory.vue?vue&type=script&lang=js"
export * from "./ModalCategory.vue?vue&type=script&lang=js"
import style0 from "./ModalCategory.vue?vue&type=style&index=0&id=a3eb52f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports